import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Menu,
  HelpCircle,
  Settings,
  LogOut,
  ChevronDown,
  Info,
} from "lucide-react";
import { CiLogout } from "react-icons/ci";
import styles from "../../styles/__insuranceDashboardLayout.module.scss";
import { IoNotifications } from "react-icons/io5";
import { HiMiniLanguage } from "react-icons/hi2";
import Logo from "../../assets/images/logo.png";
import UserAvatar from "../../assets/images/user.png";
import AddIcon from "../../assets/images/addIconHeader.png";

const InsuranceDashboardLayout = ({
  children,
  currentPage,
  onNavigate,
  onLogout,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("English");
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] =
    useState(false);

  const [openMenu, setOpenMenu] = useState(currentPage);

  const navigate = useNavigate();

  const languages = [
    { code: "en", name: "English", flag: "Flag_of_United_States-64x34.png" },
    { code: "tr", name: "Türkçe", flag: "Flag_of_Egypt-64x43.png" },
    { code: "ar", name: "العربية", flag: "Flag_of_Iraq-64x43.png" },
    { code: "ku", name: "کوردی", flag: "Flag_of_Algeria-64x43.png" },
    { code: "fa", name: "فارسی", flag: "Flag_of_Albania-64x46.png" },
  ];

  const notifications = [
    {
      id: 1,
      type: "appointment",
      title: "New Claim Request",
      message: null,
      time: "2:00 pm",
      icon: "new-claim",
    },
    {
      id: 2,
      type: "appointment",
      title: "Johan Lee's insurance claim #CLM301 approved successfully. ",
      message: "Doctor's Consultation | Fully Approved",
      time: "2:00 pm",
      icon: "success",
    },
    {
      id: 3,
      type: "appointment",
      title: "Jessica Ruth's insurance claim #CLM302 rejected. ",
      message: "Medical Order | Medication not eligible for insurance cover",
      time: "2:00 pm",
      icon: "reject",
    },
    {
      id: 4,
      type: "appointment",
      title: "#CLM203 time elapsed SLA, status changed to rejected. ",
      message: "Medical Order | Time elapsed SLA Delay in response",
      time: "2:00 pm",
      icon: "warning",
    },
  ];

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language.name);
    setIsLanguageDropdownOpen(false);
  };

  const toggleNotificationDropdown = () => {
    setIsNotificationDropdownOpen(!isNotificationDropdownOpen);
  };

  const getNotificationIcon = (iconType) => {
    switch (iconType) {
      case "new-claim":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" fill="#EFF6FF" />
            <path
              d="M16 21L19.3333 17.6667L18.1667 16.5L16.8333 17.8333V14.3333H15.1667V17.8333L13.8333 16.5L12.6667 17.6667L16 21ZM10.1667 23.5C9.70833 23.5 9.31597 23.3368 8.98958 23.0104C8.66319 22.684 8.5 22.2917 8.5 21.8333V11.4375C8.5 11.2431 8.53125 11.0556 8.59375 10.875C8.65625 10.6944 8.75 10.5278 8.875 10.375L9.91667 9.10417C10.0694 8.90972 10.2604 8.76042 10.4896 8.65625C10.7188 8.55208 10.9583 8.5 11.2083 8.5H20.7917C21.0417 8.5 21.2812 8.55208 21.5104 8.65625C21.7396 8.76042 21.9306 8.90972 22.0833 9.10417L23.125 10.375C23.25 10.5278 23.3438 10.6944 23.4062 10.875C23.4688 11.0556 23.5 11.2431 23.5 11.4375V21.8333C23.5 22.2917 23.3368 22.684 23.0104 23.0104C22.684 23.3368 22.2917 23.5 21.8333 23.5H10.1667ZM10.5 11H21.5L20.7917 10.1667H11.2083L10.5 11Z"
              fill="#2B7FFF"
            />
          </svg>
        );
      case "success":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" fill="#ECFDF5" />
            <path
              d="M11.5843 21L6.87598 16.2917L8.06348 15.125L11.6051 18.6667L12.7718 19.8333L11.5843 21ZM16.2926 21L11.5843 16.2917L12.751 15.1042L16.2926 18.6458L23.9593 10.9792L25.126 12.1667L16.2926 21ZM16.2926 16.2917L15.1051 15.125L19.2301 11L20.4176 12.1667L16.2926 16.2917Z"
              fill="#00BC7D"
            />
          </svg>
        );
      case "reject":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" fill="#FFF1F2" />
            <path
              d="M11.3337 21.8333L10.167 20.6667L14.8337 16L10.167 11.3333L11.3337 10.1667L16.0003 14.8333L20.667 10.1667L21.8337 11.3333L17.167 16L21.8337 20.6667L20.667 21.8333L16.0003 17.1667L11.3337 21.8333Z"
              fill="#FF2056"
            />
          </svg>
        );
      case "warning":
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" fill="#FFFBEB" />
            <path
              d="M8.27098 23.5C8.11821 23.5 7.97932 23.4618 7.85432 23.3854C7.72932 23.309 7.63209 23.2083 7.56265 23.0833C7.49321 22.9583 7.45501 22.8229 7.44807 22.6771C7.44112 22.5312 7.47932 22.3889 7.56265 22.25L15.271 8.91667C15.3543 8.77778 15.462 8.67361 15.5939 8.60417C15.7258 8.53472 15.8613 8.5 16.0001 8.5C16.139 8.5 16.2745 8.53472 16.4064 8.60417C16.5383 8.67361 16.646 8.77778 16.7293 8.91667L24.4376 22.25C24.521 22.3889 24.5592 22.5312 24.5522 22.6771C24.5453 22.8229 24.5071 22.9583 24.4376 23.0833C24.3682 23.2083 24.271 23.309 24.146 23.3854C24.021 23.4618 23.8821 23.5 23.7293 23.5H8.27098ZM16.0001 21C16.2363 21 16.4342 20.9201 16.5939 20.7604C16.7536 20.6007 16.8335 20.4028 16.8335 20.1667C16.8335 19.9306 16.7536 19.7326 16.5939 19.5729C16.4342 19.4132 16.2363 19.3333 16.0001 19.3333C15.764 19.3333 15.5661 19.4132 15.4064 19.5729C15.2467 19.7326 15.1668 19.9306 15.1668 20.1667C15.1668 20.4028 15.2467 20.6007 15.4064 20.7604C15.5661 20.9201 15.764 21 16.0001 21ZM16.0001 18.5C16.2363 18.5 16.4342 18.4201 16.5939 18.2604C16.7536 18.1007 16.8335 17.9028 16.8335 17.6667V15.1667C16.8335 14.9306 16.7536 14.7326 16.5939 14.5729C16.4342 14.4132 16.2363 14.3333 16.0001 14.3333C15.764 14.3333 15.5661 14.4132 15.4064 14.5729C15.2467 14.7326 15.1668 14.9306 15.1668 15.1667V17.6667C15.1668 17.9028 15.2467 18.1007 15.4064 18.2604C15.5661 18.4201 15.764 18.5 16.0001 18.5Z"
              fill="#FE9A00"
            />
          </svg>
        );
      default:
        return <Calendar size={20} className="dl-notification-icon-blue" />;
    }
  };

  const DoctorIcon = () => (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16628 10.9995C12.1994 10.9995 14.6661 8.53289 14.6661 5.49977C14.6661 2.46665 12.1994 0 9.16628 0C6.13316 0 3.66651 2.46665 3.66651 5.49977C3.66651 8.53289 6.13316 10.9995 9.16628 10.9995ZM9.16628 1.83326C11.1884 1.83326 12.8328 3.47769 12.8328 5.49977C12.8328 7.52185 11.1884 9.16628 9.16628 9.16628C7.1442 9.16628 5.49977 7.52185 5.49977 5.49977C5.49977 3.47769 7.1442 1.83326 9.16628 1.83326ZM18.3326 21.0825C18.3326 21.5893 17.9228 21.9991 17.4159 21.9991C16.909 21.9991 16.4993 21.5893 16.4993 21.0825C16.4993 18.5287 14.9988 16.3178 12.8328 15.2857V17.5736C13.8998 17.9522 14.6661 18.9705 14.6661 20.1658V21.0825C14.6661 21.5893 14.2563 21.9991 13.7494 21.9991C13.2425 21.9991 12.8328 21.5893 12.8328 21.0825V20.1658C12.8328 19.6598 12.4221 19.2492 11.9162 19.2492C11.4102 19.2492 10.9995 19.6598 10.9995 20.1658V21.0825C10.9995 21.5893 10.5898 21.9991 10.0829 21.9991C9.57602 21.9991 9.16628 21.5893 9.16628 21.0825V20.1658C9.16628 18.9705 9.93259 17.9522 10.9995 17.5736V14.7321C10.6998 14.689 10.3937 14.6661 10.0829 14.6661H8.24966C7.6126 14.6661 6.99754 14.7596 6.4164 14.9337V17.6625C6.96454 17.9797 7.33303 18.5718 7.33303 19.2501C7.33303 20.263 6.51265 21.0834 5.49977 21.0834C4.4869 21.0834 3.66651 20.263 3.66651 19.2501C3.66651 18.5718 4.035 17.9797 4.58314 17.6625V15.821C2.92221 16.9824 1.83326 18.9082 1.83326 21.0834C1.83326 21.5903 1.42352 22 0.916628 22C0.409733 22 0 21.5903 0 21.0834C0 16.5341 3.70043 12.8337 8.24966 12.8337H10.0829C14.6321 12.8337 18.3326 16.5332 18.3326 21.0825Z"
        fill="#374151"
      />
    </svg>
  );

  const Calendar = () => (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.14258 1.75C7.34149 1.75 7.53226 1.82902 7.67291 1.96967C7.81356 2.11032 7.89258 2.30109 7.89258 2.5V3.263C8.55458 3.25 9.28358 3.25 10.0866 3.25H14.1986C15.0016 3.25 15.7306 3.25 16.3926 3.263V2.5C16.3926 2.30109 16.4716 2.11032 16.6122 1.96967C16.7529 1.82902 16.9437 1.75 17.1426 1.75C17.3415 1.75 17.5323 1.82902 17.6729 1.96967C17.8136 2.11032 17.8926 2.30109 17.8926 2.5V3.327C18.1526 3.347 18.3989 3.37233 18.6316 3.403C19.8036 3.561 20.7526 3.893 21.5016 4.641C22.2496 5.39 22.5816 6.339 22.7396 7.511C22.7889 7.88567 22.8246 8.29567 22.8466 8.741C22.901 8.88855 22.9076 9.04947 22.8656 9.201C22.8926 10.002 22.8926 10.913 22.8926 11.944V14.056C22.8926 15.894 22.8926 17.35 22.7396 18.489C22.5816 19.661 22.2496 20.61 21.5016 21.359C20.7526 22.107 19.8036 22.439 18.6316 22.597C17.4916 22.75 16.0366 22.75 14.1986 22.75H10.0866C8.24858 22.75 6.79258 22.75 5.65358 22.597C4.48158 22.439 3.53258 22.107 2.78358 21.359C2.03558 20.61 1.70358 19.661 1.54558 18.489C1.39258 17.349 1.39258 15.894 1.39258 14.056V11.944C1.39258 10.913 1.39258 10.002 1.41958 9.2C1.37785 9.04836 1.38485 8.88744 1.43958 8.74C1.46091 8.29533 1.49624 7.88567 1.54558 7.511C1.70358 6.339 2.03558 5.39 2.78358 4.641C3.53258 3.893 4.48158 3.561 5.65358 3.403C5.88691 3.37233 6.13324 3.347 6.39258 3.327V2.5C6.39258 2.30109 6.4716 2.11032 6.61225 1.96967C6.7529 1.82902 6.94367 1.75 7.14258 1.75ZM2.90558 9.75C2.89258 10.403 2.89258 11.146 2.89258 12V14C2.89258 15.907 2.89458 17.262 3.03258 18.29C3.16758 19.295 3.42158 19.875 3.84458 20.298C4.26758 20.721 4.84758 20.975 5.85358 21.11C6.88158 21.248 8.23558 21.25 10.1426 21.25H14.1426C16.0496 21.25 17.4046 21.248 18.4326 21.11C19.4376 20.975 20.0176 20.721 20.4406 20.298C20.8636 19.875 21.1176 19.295 21.2526 18.289C21.3906 17.262 21.3926 15.907 21.3926 14V12C21.3926 11.146 21.3926 10.403 21.3796 9.75H2.90558ZM21.3106 8.25H2.97458C2.99058 8.06067 3.00991 7.88067 3.03258 7.71C3.16758 6.705 3.42158 6.125 3.84458 5.702C4.26758 5.279 4.84758 5.025 5.85358 4.89C6.88158 4.752 8.23558 4.75 10.1426 4.75H14.1426C16.0496 4.75 17.4046 4.752 18.4326 4.89C19.4376 5.025 20.0176 5.279 20.4406 5.702C20.8636 6.125 21.1176 6.705 21.2526 7.711C21.2752 7.881 21.2946 8.06067 21.3106 8.25ZM16.6426 15.75C16.4437 15.75 16.2529 15.829 16.1122 15.9697C15.9716 16.1103 15.8926 16.3011 15.8926 16.5C15.8926 16.6989 15.9716 16.8897 16.1122 17.0303C16.2529 17.171 16.4437 17.25 16.6426 17.25C16.8415 17.25 17.0323 17.171 17.1729 17.0303C17.3136 16.8897 17.3926 16.6989 17.3926 16.5C17.3926 16.3011 17.3136 16.1103 17.1729 15.9697C17.0323 15.829 16.8415 15.75 16.6426 15.75ZM14.3926 16.5C14.3926 16.2045 14.4508 15.9119 14.5638 15.639C14.6769 15.366 14.8427 15.1179 15.0516 14.909C15.2605 14.7001 15.5086 14.5343 15.7815 14.4213C16.0545 14.3082 16.3471 14.25 16.6426 14.25C16.9381 14.25 17.2306 14.3082 17.5036 14.4213C17.7766 14.5343 18.0246 14.7001 18.2336 14.909C18.4425 15.1179 18.6082 15.366 18.7213 15.639C18.8344 15.9119 18.8926 16.2045 18.8926 16.5C18.8926 17.0967 18.6555 17.669 18.2336 18.091C17.8116 18.5129 17.2393 18.75 16.6426 18.75C16.0458 18.75 15.4735 18.5129 15.0516 18.091C14.6296 17.669 14.3926 17.0967 14.3926 16.5Z"
        fill="#374151"
      />
    </svg>
  );

  const MedicalIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2526 20.7504H5.87738C4.43007 20.7504 3.25227 19.5726 3.25227 18.1253V12C3.25227 10.5527 4.43007 9.37493 5.87738 9.37493H6.75242C7.23544 9.37493 7.62745 8.98291 7.62745 8.49989V6.74982H11.104L11.1276 8.51126C11.1337 8.98991 11.524 9.37493 12.0026 9.37493H12.8777C14.0765 9.37493 15.1213 10.1843 15.4197 11.3438C15.5387 11.8154 16.0304 12.0937 16.4854 11.9729C16.9536 11.8522 17.2354 11.3753 17.1155 10.9071C16.6176 8.97503 14.8745 7.62573 12.8777 7.62573L12.8575 6.59581C13.8848 6.2388 14.6277 5.27275 14.6277 4.12558C14.6277 2.67827 13.4499 1.50047 12.0026 1.50047H6.75242C5.30511 1.50047 4.12731 2.67827 4.12731 4.12558C4.12731 5.26488 4.86146 6.22742 5.87738 6.58968V7.62573C3.46578 7.62485 1.5022 9.58756 1.5022 12V18.1253C1.5022 20.5378 3.46578 22.5005 5.87738 22.5005H10.2526C10.7356 22.5005 11.1276 22.1085 11.1276 21.6254C11.1276 21.1424 10.7356 20.7504 10.2526 20.7504ZM6.75242 3.24967H12.0026C12.4848 3.24967 12.8777 3.64256 12.8777 4.12471C12.8777 4.60685 12.4848 4.99974 12.0026 4.99974H6.75242C6.27027 4.99974 5.87738 4.60685 5.87738 4.12471C5.87738 3.64256 6.27027 3.24967 6.75242 3.24967ZM12.8777 14.6251C12.8777 15.1082 12.4857 15.5002 12.0026 15.5002H10.2526V17.2503C10.2526 17.7333 9.86055 18.1253 9.37752 18.1253C8.89451 18.1253 8.50249 17.7333 8.50249 17.2503V15.5002H6.75242C6.2694 15.5002 5.87738 15.1082 5.87738 14.6251C5.87738 14.1421 6.2694 13.7501 6.75242 13.7501H8.50249V12C8.50249 11.517 8.89451 11.125 9.37752 11.125C9.86055 11.125 10.2526 11.517 10.2526 12V13.7501H12.0026C12.4857 13.7501 12.8777 14.1421 12.8777 14.6251ZM21.6062 13.772C20.4494 12.6152 18.4324 12.6152 17.2756 13.772L13.7755 17.2721C12.5872 18.4123 12.5872 20.4634 13.7755 21.6036C14.9156 22.791 16.9658 22.7919 18.106 21.6036L21.6062 18.1034C22.7945 16.9632 22.7945 14.9113 21.6062 13.772ZM15.0128 20.3663C14.5035 19.878 14.5035 18.9986 15.0128 18.5103L16.1932 17.3299L18.0491 19.1858L16.8687 20.3663C16.3577 20.8782 15.5238 20.8782 15.0128 20.3663ZM20.3689 16.8661L19.2864 17.9485L17.4305 16.0926L18.5129 15.0102C19.0248 14.4983 19.8578 14.4983 20.3689 15.0102C20.8781 15.4984 20.8781 16.3778 20.3689 16.8661Z"
        fill="#2D2D37"
      />
    </svg>
  );

  const labIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.577 10.9226C20.7395 11.0851 20.9528 11.1668 21.1662 11.1668C21.3795 11.1668 21.5928 11.0851 21.7553 10.9226C22.0811 10.5968 22.0811 10.0702 21.7553 9.74434L14.2557 2.24473C13.9299 1.91891 13.4032 1.91891 13.0774 2.24473C12.7516 2.57054 12.7516 3.09718 13.0774 3.423L13.8815 4.22713L3.22126 14.8866C2.43463 15.6732 2.00049 16.7198 2.00049 17.8331C2.00049 18.9464 2.43463 19.9921 3.22126 20.7796C4.00788 21.5671 5.05366 21.9995 6.16694 21.9995C7.28021 21.9995 8.32599 21.5662 9.11262 20.7796L19.7729 10.1193L20.577 10.9234V10.9226ZM7.93435 19.6013C6.99023 20.5454 5.34365 20.5454 4.39953 19.6013C3.42458 18.6264 3.42458 17.0406 4.39953 16.0657L10.9092 9.55602L14.4448 13.0917L7.93518 19.6013H7.93435ZM15.6223 11.9134L12.0866 8.37774L15.059 5.4054L18.5946 8.94105L15.6223 11.9134ZM19.9604 15.0282C19.2488 14.3308 18.0855 14.3308 17.3722 15.0282C17.3514 15.0482 16.3097 16.3107 16.3097 16.3107C15.6798 16.9398 15.3331 17.7773 15.3331 18.6672C15.3331 19.5572 15.6798 20.3946 16.3097 21.0238C16.9397 21.6537 17.7763 22.0004 18.6663 22.0004C19.5562 22.0004 20.3929 21.6537 21.0228 21.0238C21.6528 20.3946 21.9994 19.5572 21.9994 18.6672C21.9994 17.7773 21.6528 16.9398 21.0762 16.3682C21.0762 16.3682 19.9829 15.0491 19.9612 15.0282H19.9604ZM19.8437 19.8455C19.2138 20.4754 18.1171 20.4754 17.4872 19.8455C17.1722 19.5305 16.9989 19.1122 16.9989 18.6672C16.9989 18.2222 17.1722 17.8039 17.5397 17.4314L18.5563 16.2032C18.623 16.154 18.7113 16.1557 18.7754 16.2032L19.8437 17.4889C20.1587 17.8039 20.332 18.2222 20.332 18.6672C20.332 19.1122 20.1587 19.5305 19.8437 19.8455Z"
        fill="#2D2D37"
      />
    </svg>
  );

  const icmIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_70304_6730)">
        <path
          d="M6.99993 11.7498C8.92851 11.7498 10.9849 12.515 12.3036 13.1092C12.7787 13.3231 13.2819 13.5493 13.6777 13.8972C14.1144 14.2813 14.3839 14.772 14.5253 15.4353L14.5595 15.658C14.5933 16.0048 14.5403 16.3698 14.4365 16.7078C14.9097 16.6443 15.4129 16.5725 15.9218 16.493C17.4345 16.2566 18.9356 15.9839 19.7226 15.8367L19.7236 15.8357C20.0961 15.7666 20.6769 15.6694 21.2509 15.8855C21.8902 16.1272 22.6877 16.7019 23.0517 17.9519C23.4233 19.2281 22.5115 20.2967 21.5322 20.6756C20.4192 21.1061 18.6961 21.7446 16.954 22.2762C15.2396 22.7993 13.4113 23.2497 12.1298 23.2498C9.00415 23.2498 6.29543 22.8578 4.36711 22.4656C3.40235 22.2694 2.63046 22.0731 2.09758 21.9246C1.83125 21.8504 1.62422 21.7881 1.48235 21.7439C1.41157 21.7219 1.35696 21.7035 1.31926 21.6912C1.30061 21.6851 1.28558 21.681 1.27532 21.6775C1.27018 21.6758 1.26559 21.6736 1.26262 21.6726C1.26147 21.6722 1.26049 21.6719 1.25969 21.6717H1.25774C0.8658 21.5377 0.655966 21.1105 0.789966 20.7185C0.923997 20.3269 1.35036 20.1181 1.74211 20.2517C1.74351 20.2522 1.74737 20.2535 1.7509 20.2547C1.75802 20.2571 1.76948 20.2613 1.78508 20.2664C1.81629 20.2766 1.86465 20.2914 1.92864 20.3113C2.05676 20.3512 2.249 20.4094 2.49993 20.4793C3.00235 20.6193 3.7396 20.8075 4.66594 20.9959C6.51995 21.3729 9.1264 21.7498 12.1298 21.7498C13.1623 21.7497 14.7952 21.3665 16.5156 20.8416C18.2084 20.325 19.8941 19.7006 20.9911 19.2762C21.5187 19.0721 21.6924 18.6477 21.6122 18.3719C21.3982 17.6363 20.9842 17.3881 20.7216 17.2888C20.5787 17.2355 20.3783 17.2407 19.998 17.3113L19.997 17.3103C19.2034 17.4588 17.6865 17.7358 16.1532 17.9754C14.6407 18.2117 13.0449 18.4236 12.1298 18.4236C11.4626 18.4236 10.6402 18.3266 10.0087 18.2351C9.68788 18.1887 9.40638 18.142 9.20501 18.1072C9.10421 18.0898 9.02297 18.0755 8.96672 18.0652C8.93867 18.0601 8.91641 18.0554 8.90129 18.0525C8.89425 18.0512 8.88867 18.0503 8.88469 18.0496C8.88288 18.0492 8.88092 18.0488 8.87981 18.0486H8.87786L8.87688 18.0476C8.47043 17.9695 8.2044 17.5773 8.28215 17.1707C8.36005 16.764 8.75242 16.4973 9.15911 16.575C9.15979 16.5751 9.16242 16.5757 9.16399 16.576C9.16714 16.5766 9.17238 16.5777 9.17864 16.5789C9.19178 16.5814 9.21165 16.5849 9.23723 16.5896C9.28911 16.5991 9.36551 16.6122 9.46087 16.6287C9.65201 16.6617 9.91938 16.7057 10.2236 16.7498C10.8327 16.838 11.5529 16.9201 12.1034 16.9226L12.6015 16.8826C12.5863 16.8838 12.7346 16.8555 12.9013 16.5271C13.0554 16.2237 13.0921 15.9062 13.0585 15.7488C12.9724 15.3452 12.8424 15.1594 12.6874 15.0232C12.4914 14.8509 12.2091 14.7113 11.6894 14.4773C10.4141 13.9026 8.59754 13.2498 6.99993 13.2498C5.85918 13.2498 4.56689 13.5462 3.52922 13.8592C3.01698 14.0137 2.57966 14.1683 2.27141 14.284C2.11748 14.3417 1.99577 14.3897 1.91399 14.4226C1.87336 14.439 1.84238 14.4514 1.82219 14.4597C1.81208 14.464 1.80436 14.4676 1.79973 14.4695L1.79485 14.4715C1.41405 14.6342 0.973334 14.4576 0.810474 14.0769C0.647706 13.696 0.825089 13.2553 1.20598 13.0926L1.20696 13.0916L1.20891 13.0906C1.2108 13.0898 1.21355 13.089 1.21672 13.0877C1.22357 13.0848 1.23364 13.0801 1.24602 13.075C1.27096 13.0646 1.30741 13.0496 1.35344 13.031C1.44543 12.9939 1.578 12.942 1.74407 12.8797C2.07641 12.755 2.5455 12.5886 3.09563 12.4226C4.18294 12.0947 5.64073 11.7498 6.99993 11.7498ZM17.0048 0.750763C17.4339 0.748341 17.8625 0.777703 18.287 0.83963L18.2929 0.840607C19.1782 0.976627 19.6606 1.74172 19.6865 2.48318V2.48514C19.706 3.0807 19.7179 3.67645 19.7275 4.27225C20.5099 4.28467 21.1006 4.29875 21.5165 4.31326L21.6552 4.32401C22.3046 4.39617 22.9412 4.8151 23.1269 5.54568L23.1601 5.70682V5.71268C23.2225 6.13886 23.2528 6.56909 23.2499 6.99979C23.2499 7.53136 23.2109 7.95881 23.1601 8.29178C23.0241 9.1773 22.2581 9.66053 21.5165 9.68631H21.5146C20.9187 9.70585 20.3226 9.71777 19.7265 9.72733C19.7141 10.5097 19.701 11.1004 19.6865 11.5164C19.6607 12.258 19.1784 13.0239 18.2929 13.1599L18.288 13.1609C17.8617 13.2233 17.4308 13.2517 16.9999 13.2488H16.997L16.9941 13.2498C16.4651 13.2495 16.0397 13.2105 15.7079 13.1599C14.8775 13.0324 14.4005 12.351 14.3232 11.6551L14.3134 11.5164C14.2989 11.1008 14.2848 10.5098 14.2724 9.72733C13.9946 9.72291 13.7409 9.72073 13.5107 9.71561L12.4833 9.68631C11.742 9.66054 10.9761 9.1787 10.8398 8.29373L10.8046 8.02518C10.7719 7.73877 10.7499 7.39805 10.7499 6.99979C10.7499 6.46812 10.789 6.04077 10.8398 5.70779C10.9758 4.82247 11.7418 4.33903 12.4833 4.31326H12.4853C13.0808 4.29373 13.6766 4.28083 14.2724 4.27127C14.2848 3.4894 14.2989 2.8989 14.3134 2.48318C14.3376 1.788 14.7632 1.07165 15.5458 0.872833L15.7118 0.83963C16.1366 0.777466 16.5658 0.748151 16.995 0.750763C16.9967 0.750752 16.9983 0.750773 16.9999 0.750763C17.0018 0.750775 17.004 0.749773 17.0058 0.749787L17.0048 0.750763ZM12.2499 6.99979C12.2499 7.45769 12.2829 7.80951 12.3222 8.06424L12.3232 8.06522C12.3279 8.09597 12.3393 8.1147 12.3632 8.13358C12.3925 8.15668 12.4496 8.18425 12.5351 8.18729C12.7966 8.19641 13.132 8.20643 13.5439 8.21561L15.0185 8.24002L15.1669 8.25565C15.5035 8.32708 15.7567 8.62425 15.7607 8.98123C15.7731 10.1249 15.7942 10.9408 15.8124 11.4637C15.8154 11.5494 15.8431 11.6071 15.8661 11.6365C15.885 11.6604 15.9038 11.6728 15.9345 11.6775L16.1445 11.7049C16.3733 11.7309 16.6569 11.7498 16.9999 11.7498H17.0058C17.3607 11.7524 17.7152 11.7277 18.0663 11.6765C18.0964 11.6717 18.1151 11.6602 18.1337 11.6365C18.1568 11.6071 18.1844 11.55 18.1874 11.4646C18.2057 10.9412 18.2267 10.1254 18.2392 8.98123C18.2437 8.57301 18.5741 8.24289 18.9823 8.23904C19.8099 8.23144 20.6376 8.21441 21.4648 8.18729L21.5234 8.18143C21.5771 8.17137 21.6146 8.15093 21.6366 8.13358C21.6606 8.1147 21.6719 8.09597 21.6767 8.06522C21.7158 7.80829 21.7499 7.45666 21.7499 6.99979V6.9949C21.7525 6.63984 21.7279 6.28473 21.6767 5.93338C21.6719 5.90286 21.6605 5.88479 21.6366 5.866C21.6073 5.84293 21.5501 5.81532 21.4648 5.81229C20.9414 5.79402 20.1251 5.77297 18.9814 5.76053C18.5731 5.75609 18.243 5.42568 18.2392 5.01736C18.2315 4.19004 18.2145 3.36283 18.1874 2.53592L18.1806 2.47635C18.1705 2.42281 18.151 2.38505 18.1337 2.36307C18.1151 2.33943 18.0964 2.32787 18.0663 2.32303C17.7149 2.27199 17.3599 2.24737 17.0048 2.24979H16.9941C16.6389 2.24721 16.284 2.27174 15.9325 2.32303C15.903 2.32796 15.8846 2.33968 15.8661 2.36307C15.843 2.39243 15.8154 2.45024 15.8124 2.53592C15.7942 3.05928 15.7731 3.87457 15.7607 5.01834C15.7562 5.4266 15.4258 5.75668 15.0175 5.76053C14.1896 5.76814 13.3616 5.78417 12.5341 5.81131L12.5351 5.81229C12.4498 5.81532 12.3926 5.84293 12.3632 5.866C12.3512 5.87548 12.3423 5.88526 12.3359 5.89627L12.3232 5.93436C12.284 6.19128 12.2499 6.54277 12.2499 6.99979Z"
          fill="#2D2D37"
        />
      </g>
      <defs>
        <clipPath id="clip0_70304_6730">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  const claimHistoryIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9808 20.5C9.97067 20.5 8.19892 19.8865 6.66559 18.6595C5.13226 17.4327 4.14951 15.8628 3.71734 13.95C3.66351 13.7513 3.69592 13.5687 3.81459 13.402C3.93309 13.2353 4.10101 13.1385 4.31834 13.1115C4.52284 13.0847 4.70617 13.1251 4.86834 13.2327C5.03051 13.3404 5.14367 13.4987 5.20784 13.7078C5.58851 15.2526 6.40867 16.5208 7.66834 17.5125C8.92801 18.5042 10.3655 19 11.9808 19C13.9308 19 15.585 18.3208 16.9433 16.9625C18.3017 15.6042 18.9808 13.95 18.9808 12C18.9808 10.05 18.3017 8.39583 16.9433 7.0375C15.585 5.67917 13.9308 5 11.9808 5C10.8885 5 9.86484 5.24267 8.90984 5.728C7.95467 6.21317 7.13217 6.88075 6.44234 7.73075H8.30784C8.52034 7.73075 8.69842 7.80267 8.84209 7.9465C8.98592 8.09033 9.05784 8.2685 9.05784 8.481C9.05784 8.69367 8.98592 8.87175 8.84209 9.01525C8.69842 9.15892 8.52034 9.23075 8.30784 9.23075H4.88484C4.62867 9.23075 4.41401 9.14408 4.24084 8.97075C4.06751 8.79758 3.98084 8.58292 3.98084 8.32675V4.90375C3.98084 4.69125 4.05276 4.51317 4.19659 4.3695C4.34042 4.22567 4.51867 4.15375 4.73134 4.15375C4.94384 4.15375 5.12192 4.22567 5.26559 4.3695C5.40909 4.51317 5.48084 4.69125 5.48084 4.90375V6.523C6.29234 5.56533 7.26417 4.82208 8.39634 4.29325C9.52834 3.76442 10.7232 3.5 11.9808 3.5C13.1608 3.5 14.2661 3.72308 15.2966 4.16925C16.3271 4.61542 17.2257 5.22183 17.9923 5.9885C18.759 6.75517 19.3654 7.65367 19.8116 8.684C20.2578 9.7145 20.4808 10.8197 20.4808 11.9995C20.4808 13.1793 20.2578 14.2846 19.8116 15.3152C19.3654 16.3461 18.759 17.2448 17.9923 18.0115C17.2257 18.7782 16.3271 19.3846 15.2966 19.8307C14.2661 20.2769 13.1608 20.5 11.9808 20.5ZM12.7596 11.6962L15.5096 14.4462C15.6481 14.5846 15.7189 14.7586 15.7221 14.9683C15.7254 15.1779 15.6546 15.3552 15.5096 15.5C15.3648 15.6448 15.1892 15.7172 14.9828 15.7172C14.7763 15.7172 14.6007 15.6448 14.4558 15.5L11.5308 12.575C11.4373 12.4813 11.3688 12.3793 11.3251 12.269C11.2816 12.1587 11.2598 12.0447 11.2598 11.927V7.75C11.2598 7.5375 11.3317 7.35933 11.4753 7.2155C11.6192 7.07183 11.7974 7 12.0101 7C12.2226 7 12.4007 7.07183 12.5443 7.2155C12.6878 7.35933 12.7596 7.5375 12.7596 7.75V11.6962Z"
        fill="#2D2D37"
      />
    </svg>
  );

  const navItems = [
    {
      id: "medicalDash",
      label: "Medical Orders",
      icon: MedicalIcon,
      path: "/i_dashboard",
    },
    {
      id: "doctorDash",
      label: "Doctor Consultation",
      icon: DoctorIcon,
      path: "/idoctor_dashboard",
    },
    {
      id: "labDash",
      label: "Lab and Imaging Center Tests",
      icon: labIcon,
      path: "/ilab_dashboard",
    },
    // {
    //     id: "icmDash",
    //     label: "Insurance Company Management",
    //     icon: icmIcon,
    //     path: "/idoctor_dashboard",
    // },
    {
      id: "claimHistoryDash",
      label: "Claim History",
      icon: claimHistoryIcon,
      path: "/iclaim-history_dashboard",
    },
  ];
  return (
    <div className={styles["dl-dashboard"]}>
      {/* Header */}

      <header className={styles["dl-header"]}>
        <div className={styles["dl-header-left"]}>
          <button
            className={styles["dl-mobile-menu-btn"]}
            onClick={toggleSidebar}
          >
            <Menu size={24} />
          </button>
          <div className={styles["dl-logo"]}>
            <img src={Logo} alt="TIRYAQ" />
          </div>
        </div>

        <div className={styles["dl-header-center"]}>
          <div className={styles["amountTagHdr"]}>
            <span>Total Approved Amount:</span>{" "}
            <b className="ms-2">IQD 230,000,000</b>
          </div>
        </div>

        <div className={styles["dl-header-right"]}>
          {/* <button className={styles["dl-settings-btn"]}>
                    <Settings size={20} />
                </button> */}
          {/* <button className={styles["dl-notification-btn"]}>
                </button> */}
          <div className={styles["dl-notification-container"]}>
            <button
              className={styles["dl-notification-btn"]}
              onClick={toggleNotificationDropdown}
            >
              <IoNotifications size={20} />
            </button>
            {isNotificationDropdownOpen && (
              <div className={styles["dl-notification-dropdown"]}>
                <div className={styles["dl-notification-list"]}>
                  {notifications.map((notification) => (
                    <div
                      key={notification.id}
                      className={styles["dl-notification-item"]}
                    >
                      <div className={styles["dl-notification-icon"]}>
                        {getNotificationIcon(notification.icon)}
                      </div>
                      <div className={styles["dl-notification-content"]}>
                        <div className={styles["dl-notification-message"]}>
                          <strong>{notification.title}</strong>
                        </div>
                        <span className={styles["dl-notification-message"]}>
                          {notification.message}
                        </span>
                      </div>
                      <div className={styles["dl-notification-time"]}>
                        {notification.time}
                      </div>
                    </div>
                  ))}
                </div>
                <div className={styles["dl-notification-footer"]}>
                  <button className={styles["dl-load-more-btn"]}>
                    Load More
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className={styles["addIconHdr"]}>
            <img src={AddIcon} alt="Add" className={styles["addIconImg"]} />
          </div>

          {/* <div className={styles["dl-language-selector"]}>
                        <button className={styles["dl-language-btn"]} onClick={() => setIsLanguageDropdownOpen(!isLanguageDropdownOpen)}>
                            <span className={styles["dl-language-icon"]}><HiMiniLanguage /> </span>
                            <span className={styles["dl-language-text"]}>{selectedLanguage}</span>
                            <ChevronDown size={16} className={`${styles["down-icon"]}`} />
                        </button>
                        {isLanguageDropdownOpen && (
                            <div className={styles["dl-language-dropdown"]}>
                                {languages.map((lang) => (
                                    <button
                                        key={lang.code}
                                        className={`${styles["dl-language-option"]} ${selectedLanguage === lang.name ? styles["active"] : ""}`}
                                        onClick={() => handleLanguageSelect(lang)}
                                    >
                                        <span className={styles["dl-flag"]}><img src={`/flags/${lang.flag}`} alt="" width={20} /></span>
                                        <span>{lang.name}</span>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div> */}
          {/* <div className={styles["dl-user-profile"]}>
                        <div className={styles["dl-rating"]}>
                            <span>RATING</span>
                            <div className={styles["dl-stars"]}>4★</div>
                        </div>
                        <div className={`dropdown ${styles["my-profile-dropdown"]}`}>
                            <span className={`dropdown-toggle ${styles["dropdown-toggle"]}`} type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src={UserAvatar} alt="User" className={styles["dl-avatar"]} />
                            </span>
                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <li><Link className={`dropdown-item ${styles["dropdown-item"]}`} to={"/my-profile"}>Profile</Link></li>
                                <li><Link className={`dropdown-item ${styles["dropdown-item"]}`} to={"/"}>Another action</Link></li>
                                <li><Link className={`dropdown-item ${styles["dropdown-item"]}`} to={"/"}>Something else</Link></li>
                            </ul>
                        </div>
                    </div> */}
        </div>
      </header>

      {/* Sidebar */}
      <aside
        className={`${styles["dl-sidebar"]} ${
          isSidebarOpen ? styles["open"] : ""
        }`}
      >
        <nav className={styles["dl-nav"]}>
          {navItems.map((item) => {
            const IconComponent = item.icon;
            // If menu has children
            if (item.children) {
              return (
                <div key={item.id} className={styles["dl-nav-group"]}>
                  <button
                    className={`${styles["dl-nav-item"]} ${
                      styles["dl-submenu-list"]
                    } ${openMenu === item.id ? styles["open"] : ""}`}
                    onClick={() =>
                      setOpenMenu(openMenu === item.id ? null : item.id)
                    }
                  >
                    <span className={`${styles["dl-submenu-list-title"]}`}>
                      <IconComponent size={20} />
                      <span>{item.label}</span>
                    </span>

                    <ChevronDown
                      size={16}
                      className={`${
                        openMenu === item.id ? styles["rotate"] : ""
                      }`}
                    />
                  </button>

                  {openMenu === item.id && (
                    <div className={styles["dl-submenu"]}>
                      {item.children.map((child) => (
                        <button
                          key={child.id}
                          className={`${styles["dl-sub-item"]} ${
                            currentPage === child.id ? styles["active"] : ""
                          }`}
                          onClick={() => {
                            navigate(child.path);
                            setIsSidebarOpen(false);
                          }}
                        >
                          <span>{child.label}</span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            }
            // If menu has no children
            return (
              <button
                key={item.id}
                className={`${styles["dl-nav-item"]} ${
                  currentPage === item.id ? styles["active"] : ""
                }`}
                onClick={() => {
                  navigate(item.path);
                  setIsSidebarOpen(false);
                }}
              >
                <IconComponent size={20} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div className={`${styles["dl-promo-banner"]} d-none`}>
          <div className={styles["dl-promo-header"]}>
            <div className={styles["dl-promo-icon"]}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.3333 8H18.6667C22.4373 8 24.324 8 25.4947 9.172C26.6667 10.3427 26.6667 12.2293 26.6667 16V17.408C26.6667 20.6147 26.6667 22.2187 25.8707 23.508C25.0733 24.796 23.6387 25.5133 20.7707 26.948C18.4293 28.1187 17.2587 28.704 16 28.704C14.7413 28.704 13.5707 28.1187 11.2293 26.948C8.36134 25.5133 6.92667 24.796 6.12934 23.508C5.33334 22.2187 5.33334 20.6133 5.33334 17.408V16C5.33334 12.2293 5.33334 10.3427 6.50534 9.172C7.676 8 9.56267 8 13.3333 8ZM16 13.3333C15.6213 13.3333 15.368 13.7867 14.8613 14.6973L14.7307 14.932C14.5867 15.1907 14.5147 15.3187 14.4027 15.404C14.2893 15.4893 14.1493 15.5213 13.8693 15.584L13.616 15.6427C12.632 15.8653 12.14 15.976 12.0227 16.352C11.9053 16.728 12.2413 17.1213 12.912 17.9053L13.0853 18.108C13.276 18.3307 13.372 18.4413 13.4147 18.58C13.4573 18.7187 13.4427 18.8667 13.4147 19.164L13.388 19.4347C13.2867 20.4813 13.236 21.0053 13.5413 21.2373C13.848 21.4693 14.3093 21.2573 15.2307 20.8333L15.468 20.724C15.7307 20.604 15.8613 20.544 16 20.544C16.1387 20.544 16.2693 20.604 16.532 20.724L16.7693 20.8333C17.6907 21.2587 18.152 21.4693 18.4587 21.2373C18.7653 21.0053 18.7133 20.4813 18.612 19.4347L18.5853 19.164C18.5573 18.8667 18.5427 18.7187 18.5853 18.58C18.628 18.4413 18.724 18.3307 18.9147 18.108L19.088 17.9053C19.7587 17.1213 20.0947 16.7293 19.9773 16.352C19.86 15.976 19.368 15.8653 18.384 15.6427L18.1307 15.584C17.8507 15.5213 17.7107 15.4907 17.5973 15.404C17.4853 15.3187 17.4133 15.1907 17.2693 14.932L17.1387 14.6973C16.632 13.7867 16.3787 13.3333 16 13.3333Z"
                  fill="#F54900"
                />
                <path
                  d="M14.6667 2.66663H17.3333C19.848 2.66663 21.104 2.66663 21.8853 3.44796C22.4373 3.99996 22.5987 4.78929 22.6467 6.09196C21.5533 5.99863 20.2587 5.99863 18.7987 5.99996H13.2C11.74 5.99996 10.4467 5.99996 9.352 6.09196C9.39866 4.78929 9.56133 3.99863 10.112 3.44796C10.896 2.66663 12.1547 2.66663 14.6667 2.66663Z"
                  fill="#F54900"
                />
              </svg>
            </div>
            <h3>Get Noticed More!</h3>
          </div>
          <div className={styles["dl-promo-content"]}>
            <p>Boost your profile visibility with a sponsored listing.</p>
            <ul>
              <li>
                <span className={styles["dl-promo-content-icon"]}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.6667 7.99992C14.6667 11.6818 11.6819 14.6666 8 14.6666C4.3181 14.6666 1.33333 11.6818 1.33333 7.99992C1.33333 4.31802 4.3181 1.33325 8 1.33325C11.6819 1.33325 14.6667 4.31802 14.6667 7.99992ZM10.6869 5.9797C10.8821 6.17496 10.8821 6.49154 10.6869 6.6868L7.35355 10.0201C7.15829 10.2154 6.84171 10.2154 6.64644 10.0201L5.31311 8.68681C5.11785 8.49154 5.11785 8.17496 5.31311 7.9797C5.50837 7.78444 5.82496 7.78444 6.02022 7.9797L7 8.95948L8.48989 7.46959L9.97978 5.9797C10.175 5.78444 10.4916 5.78444 10.6869 5.9797Z"
                      fill="#F54900"
                    />
                  </svg>
                </span>
                Higher search rankings
              </li>
              <li>
                <span className={styles["dl-promo-content-icon"]}>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M14.6667 7.99992C14.6667 11.6818 11.6819 14.6666 8 14.6666C4.3181 14.6666 1.33333 11.6818 1.33333 7.99992C1.33333 4.31802 4.3181 1.33325 8 1.33325C11.6819 1.33325 14.6667 4.31802 14.6667 7.99992ZM10.6869 5.9797C10.8821 6.17496 10.8821 6.49154 10.6869 6.6868L7.35355 10.0201C7.15829 10.2154 6.84171 10.2154 6.64644 10.0201L5.31311 8.68681C5.11785 8.49154 5.11785 8.17496 5.31311 7.9797C5.50837 7.78444 5.82496 7.78444 6.02022 7.9797L7 8.95948L8.48989 7.46959L9.97978 5.9797C10.175 5.78444 10.4916 5.78444 10.6869 5.9797Z"
                      fill="#F54900"
                    />
                  </svg>
                </span>
                Featured in specialty sections
              </li>
            </ul>
            <button className={styles["dl-promo-btn"]}>
              Learn more <Info />
            </button>
          </div>
        </div>

        <div className={styles["dl-sidebar-bottom"]}>
          <Link to={"/i_login"}>
            <button
              className={`${styles["dl-nav-item"]} ${
                currentPage === "logout" ? styles["active"] : ""
              }`}
              onClick={onLogout}
            >
              <LogOut size={20} className={styles["rotate-180"]} />
              <span>Logout</span>
            </button>
          </Link>
        </div>
      </aside>

      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div
          className={styles["dl-sidebar-overlay"]}
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}

      {/* Main Content */}
      <main className={styles["dl-main-content"]}>{children}</main>
    </div>
  );
};

export default InsuranceDashboardLayout;
